import React from 'react';
import './VideoEmbed.scss';

const VideoEmbed = ({ externalVideoEmbed }) => {
    return (
        <div
            dangerouslySetInnerHTML={{
                __html: externalVideoEmbed,
            }}></div>
    );
};

export default VideoEmbed;
